import SalesDailyReportPage from './SalesDailyReportPage';

export default SalesDailyReportPage;
